/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

import {commonTranslations} from "./common"

export const dataManagementTranslations = {
    title: commonTranslations.dataManagement,
    link: "New Dataset",
    home: {
        title: commonTranslations.home,
        projects: "Projects",
        createProject: commonTranslations.createProject,
        viewProjects: commonTranslations.viewProjects,
        datasets: commonTranslations.datasets,
        createDataset: commonTranslations.createDataSet,
        viewDatasets: "View Dataset"
    },
    dataset: {
        list: {
            title: commonTranslations.dataManagement,
            createProject: commonTranslations.createProject,
            createDataset: commonTranslations.createDataSet,
            view: "View:",
            error: commonTranslations.error,
            import: commonTranslations.import,
            importDataset: commonTranslations.import,
            exportDatasets: commonTranslations.export,
            ok: commonTranslations.ok
        },
        export: {
            title: "Data Export",
            exportSelected: "Export Selected Data",
            cancel: commonTranslations.cancel
        },
        select: {
            title: "Create Dataset - Select Sequence Data",
            cancel: commonTranslations.cancel,
            createDataset: "Create New Dataset",
            datasetType: "Dataset Type:",
            datasets: commonTranslations.datasets
        },
        detail: {
            title: "Dataset - {datasetName}",
            smrtLinkLog: commonTranslations.smrtLinkLog,
            analysisMetric: commonTranslations.analysisMetric,
            analyze: "Analyze...",
            application: commonTranslations.application,
            attributes: commonTranslations.attributes,
            cancel: commonTranslations.cancel,
            createdAt: commonTranslations.createdAt,
            data: commonTranslations.data,
            dataset: commonTranslations.dataset,
            datasetId: "Dataset Id",
            datasetOverview: "Dataset Overview",
            description: commonTranslations.description,
            delete: commonTranslations.allCapsDelete,
            displayAll: commonTranslations.displayAll,
            edit: commonTranslations.edit,
            file: commonTranslations.file,
            fileDownloads: commonTranslations.fileDownloads,
            inputs: commonTranslations.inputs,
            importedAt: commonTranslations.importedAt,
            noLogAvailable: commonTranslations.noLogAvailable,
            numberOfRecords: commonTranslations.numRecords,
            parameters: "Parameters",
            path: commonTranslations.path,
            save: commonTranslations.save,
            size: commonTranslations.size,
            status: commonTranslations.status,
            thumbnails: commonTranslations.thumbnails,
            totalLength: "Total Length",
            type: commonTranslations.type,
            updatedAt: commonTranslations.updatedAt,
            value: commonTranslations.value,
            copy: commonTranslations.copy
        },
        merge: {
            title: "Create Dataset - Settings",
            cancel: commonTranslations.cancel,
            datasetName: commonTranslations.dataSetName,
            datasetsSelected: "Datasets Selected",
            error: commonTranslations.error,
            ok: commonTranslations.ok,
            saveDataset: "Save Dataset"
        }
    },
    project: {
        list: {
            title: commonTranslations.viewProjects,
            createProject: commonTranslations.createProject,
            error: commonTranslations.error,
            ok: commonTranslations.ok
        },
        create: {
            createTitle: commonTranslations.createProject,
            editTitle: "Edit Project",
            name: "Project Name",
            description: commonTranslations.description,
            datasets: "Associated Datasets",
            members: "Members",
            cancel: commonTranslations.cancel,
            save: commonTranslations.save,
            delete: commonTranslations.delete,
            selectDatasets: "Select Datasets",
            grantRoleToAll: "Access for All SMRT Link Users",
            grantRoleToIndividual: "Access for Individual SMRT Link Users"
        }
    }
}
